import React from 'react';
import {DmsTab} from 'Components';
import {Form, Input, Select, Button, Row, Col, Tree,TreeSelect,message} from 'antd';
import {treeList, orgDetail, orgAdd, orgModify, orgDelete,orgAsyc} from '../../service/org';
import {allChildren} from '../../service/zone';
import {nameValidator,checkCode} from '../../utils/regexp.js';
import {showSpin,hideSpin,openNotice} from 'Utils';
const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;
const TreeNode = Tree.TreeNode;


class Org extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['组织架构'],
			tree: [],
			selectkey: null,
			detail: {},
			areaList:[],
			editFlag:false,//编辑
			rootFlag:false,//上一级
			childFlag:false,//下一级
			buttonFlag:true,//按钮
			disabledFlag:true,
			keys:[],
			hasFeedback:false,
			placeholder:'请选择管理区域'
		};
		this.onSelect=this.onSelect.bind(this);
		this.getData = this.getData.bind(this);
		this.getAreaList = this.getAreaList.bind(this);
		this.checkSortOrder=this.checkSortOrder.bind(this);
	}
	
	componentDidMount() {
		this.getData();
		this.getAreaList();
	}
	
	getData() {
		treeList({id: 0}).then(result => {
			if (result.status) {
				this.setState({
					tree: result.data
				})
			}else{
				message.error(result.message);
			}
		})
	}
	
	getAreaList(){
		allChildren({id: 0}).then(result => {
			if (result.status) {
				this.setState({
					areaList: result.data
				})
			}else{
				message.error(result.message);
			}
		})
	}
	
	
	//编辑
	editHandle() {
		if(this.state.selectkey!=null){
			this.setState({
				childFlag:false,
				editFlag:true,
				rootFlag:false,
				disabledFlag:false,
				hasFeedback:true
			});
		}else{
			this.cancelHandle();
		}
	}
	
	
	//删除
	deleteHandle() {
		if(this.state.selectkey!=null){
				orgDelete({id: this.state.detail.id}).then(result => {
					if (result.status) {
						message.success('删除成功');
						this.getData();
						this.cancelHandle();
					}else{
						message.error(result.message);
					}
				})
		}else{
			message.info('请选择要删除的组织');
		}
	}
	
	//添加上一级
	upSumbit() {
		this.setState({
			childFlag:false,
			editFlag:false,
			rootFlag:true,
			disabledFlag:false,
			keys:[],
			hasFeedback:true,
			placeholder:'请选择管理区域'
		})
		const {setFieldsValue} = this.props.form;
		setFieldsValue({
			name: '',
			code:'',
			type:'',
			sortOrder:'',
			active:'',
			areaIdList:[],
			description:''
		});
	}
	
	
	//添加下一级
	downSumbit() {
		if(this.state.selectkey!=null){
			this.setState({
				childFlag:true,
				editFlag:false,
				rootFlag:false,
				disabledFlag:false,
				hasFeedback:true,
				placeholder:'请选择管理区域'
			});
			const {setFieldsValue} = this.props.form;
			setFieldsValue({
				name: '',
				code:'',
				type:'',
				sortOrder:'',
				active:'',
				areaIdList:[],
				description:''
			});
		}else{
			this.setState({
				childFlag:false,
				editFlag:false,
				rootFlag:false,
				disabledFlag:true,
				hasFeedback:false,
				placeholder:'请选择管理区域'
			})
			message.info('请选择上级组织');
		}
	}
	
	
	
	onSelect(selectedKeys, info) {
		if(selectedKeys.length!=0) {
			this.setState({
				keys:selectedKeys,
				childFlag:false,
				editFlag:false,
				rootFlag:false,
				buttonFlag:false,
				disabledFlag:true,
				hasFeedback:false
			});
			const {setFieldsValue} = this.props.form;
			orgDetail({id: parseInt(selectedKeys[0], 0)}).then(result => {
				if (result.status) {
					if (result.data.active === 1) {
						result.data.active = '1';
					} else {
						result.data.active = '0';
					}
					
					switch(result.data.type){
						case 0:
							result.data.type='0'
							break;
						case 1:
							result.data.type='1'
							break;
						case 2:
							result.data.type='2'
							break;
						case 3:
							result.data.type='3'
							break;
						case 4:
							result.data.type='4'
							break;
						
						default:
							result.data.type='0'
							break;
					}
					
					if(result.data.areaList&&result.data.areaList.length>0){
						var newList=[];
						for(var a=0;a<result.data.areaList.length;a++){
							if(result.data.areaList[a]!=null){
								var areaKey=result.data.areaList[a].id.toString();
								newList.push(areaKey);
							}
						}
						result.data.areaList=newList;
					}else{
						result.data.areaList=[];
					}
					this.setState({
						selectkey: parseInt(selectedKeys[0], 0),
						detail: result.data
					});
					if(result.data.areaList!=null){
						this.setState({
							placeholder:''
						})
					}
					setFieldsValue({
						name: result.data.name,
						code: result.data.code,
						type:result.data.type,
						sortOrder:result.data.sortOrder,
						active:result.data.active,
						description:result.data.description,
						areaIdList:result.data.areaList
					});
				}
			})
		}else{
			this.cancelHandle();
		}
	}
	
	cancelHandle() {
		this.setState({
			childFlag:false,
			editFlag:false,
			rootFlag:false,
			buttonFlag:true,
			disabledFlag:true,
			keys:[],
			hasFeedback:false,
			placeholder:'请选择管理区域'
		});
		const {setFieldsValue} = this.props.form;
		setFieldsValue({
			name: '',
			code:'',
			type:'',
			sortOrder:'',
			active:'',
			areaIdList:[],
			description:''
		});
	}
	asyc(){
		orgAsyc().then(res=>{
			if (res && res.code == 200) {
				openNotice('success', '同步成功,请等待5分钟', '');
			} else {
				openNotice('error', '同步失败', (res && res.message) ? res.message : '');
			}
		});
	}
	//提交
	submitHandle() {
		const {editFlag,childFlag,rootFlag}=this.state;
		if(editFlag===false&&childFlag===false&&rootFlag===false){
			message.info('请选择要进行何种操作');
		}else{
			const {validateFields, getFieldsValue} = this.props.form;
			validateFields((errors) => {//表单校验
				if (errors) {
					return
				}//表单校验有误，则不执行下面的代码
				const data = {
					...getFieldsValue() //获取用户输入
				};
				if (data.active === '1') {
					data.active = 1;
				} else {
					data.active = 0;
				}
				switch(data.type){
					case '0':
						data.type=0
						break;
					case '1':
						data.type=1
						break;
					case '2':
						data.type=2
						break;
					case '3':
						data.type=3
						break;
					case '4':
						data.type=4
						break;
					
					default:
						data.type=0
						break;
				}
				if(data.areaIdList!=undefined&&data.areaIdList.length>0){
					var subList=[];
					for(var s=0;s<data.areaIdList.length;s++){
						var subNum=parseInt(data.areaIdList[s],0);
						subList.push(subNum);
					}
					data.areaIdList=subList;
				}else{
					data.areaIdList=[];
				}

        showSpin();
				//编辑
				if(editFlag===true&&childFlag===false&&rootFlag===false){
					data.id = this.state.detail.id;
					data.parentId = this.state.detail.parentId;
					orgModify(data).then(result => {
						hideSpin();
						if (result.status) {
							this.getData();
							this.cancelHandle();
							message.success('修改成功');
						}else{
							message.error(result.message);
						}
					})
				}
				//新增上一级
				if(editFlag===false&&childFlag===false&&rootFlag===true){
					data.parentId = 0;
					orgAdd(data).then(result=>{
						hideSpin();
						if(result.status){
							this.getData();
							this.cancelHandle();
							message.success('添加成功');
						}else{
							message.error(result.message);
						}
					})
				}
				//新增下一级
				if(editFlag===false&&childFlag===true&&rootFlag===false){
					data.parentId = this.state.detail.id;
					orgAdd(data).then(result=>{
						hideSpin();
						if(result.status){
							this.getData();
							this.cancelHandle();
							message.success('添加成功');
						}else{
							message.error(result.message);
						}
					})
				}
				
			})
		}
	}
	
	//排序正则
	checkSortOrder(rule, value, callback) {
		const vaReg = /^\d{1,}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('排序只可输入整数');
			}
			callback();
		}
		callback();
	}
	
	
	render () {
		const { opts,disabledFlag,buttonFlag,hasFeedback,keys} = this.state;
		const {getFieldDecorator} = this.props.form;
		
		const loop = data => data.map((item,key) => {
			if (item.child && item.child.length) {
				return <TreeNode key={item.id} title={item.name}>{loop(item.child)}</TreeNode>;
			}
			return <TreeNode key={item.id} title={item.name} />;
		});
		
		return <div className='dms-body'>
          <DmsTab options={opts} defaultKey={0}>
						<Button icon="reload" onClick={this.asyc.bind(this)}>同步</Button>
            <Button onClick={this.upSumbit.bind(this)}>+新增上一级</Button>
            <Button onClick={this.downSumbit.bind(this)} disabled={buttonFlag}>+新增下一级</Button>
            <Button onClick={this.editHandle.bind(this)} disabled={buttonFlag}>编辑当前组织</Button>
            <Button onClick={this.deleteHandle.bind(this)} disabled={buttonFlag}>删除当前组织</Button>
          </DmsTab>
			<div className="dms-table-box"
				 style={{backgroundColor: "#fff", padding: '20px 5% 20px 35%', minHeight: '600px'}}>
				
				<div className="left"
					 style={{
						 width: "27%",
						 display: 'inline-block',
						 height: '90%',
						 overflow: 'auto',
						 marginRight: '3%',
						 position: 'absolute',
						 left: '5%',
						 top: '20px'
					 }}>
              <Tree
				  defaultExpandAll
			      onSelect={this.onSelect}
				  selectedKeys={keys}
			  >
			  {loop(this.state.tree)}
              </Tree>
            </div>
				<div className='right' style={{width: "100%", display: 'inline-block'}}>
						  <Form layout="horizontal" >
							  <Row gutter={16}>
								  <Col className="gutter-row" span={12}>
									  <FormItem label="名称" hasFeedback={hasFeedback}>
										  {getFieldDecorator('name', {
											  rules: [
												  {
													  required: true,
													  message: '请输入组织名称'
												  },
												  {
													  validator: nameValidator
												  }
											  ],
										  })(<Input disabled={disabledFlag} placeholder="请输入组织名称"/>)}
									  </FormItem>
								  </Col>
								  <Col className="gutter-row" span={12}>
									  <FormItem label="编码" hasFeedback={hasFeedback}>
										  {getFieldDecorator('code', {
											  rules: [
												  {
													  required: true,
													  message: '请输入组织编码'
												  },
												  {
													  validator: checkCode
												  }
											  ],
										  })(<Input disabled={disabledFlag} placeholder="请输入组织编码"/>)}
									  </FormItem>
								  </Col>
							  </Row>
							
							  <Row gutter={16}>
								  <Col className="gutter-row" span={12}>
									  <FormItem label="类型">
										  {getFieldDecorator('type', {
											  rules: [
												  {
													  required: true,
													  message: '请选择类型'
												  },
											  ]
										  })(<Select disabled={disabledFlag}>
											  <Option value='0'>集团</Option>
											  <Option value='1'>公司</Option>
											  <Option value='2'>机构</Option>
											  <Option value='3'>部门</Option>
											  <Option value='4'>团队</Option>
										  </Select>)}
									  </FormItem>
								  </Col>
								  <Col className="gutter-row" span={12}>
									  <FormItem label="排序">
										  {getFieldDecorator('sortOrder',{
											  rules: [
												  {
													  validator: this.checkSortOrder
												  }
											  ]
										  })(<Input disabled={disabledFlag} />)}
									  </FormItem>
								  </Col>
							  </Row>
							
							  <Row gutter={16}>
								  <Col className="gutter-row" span={12}>
									  <FormItem label="有效性">
										  {getFieldDecorator('active', {
											  rules: [
												  {
													  required: true,
													  message: '请选择是否有效'
												  },
											  ]
										  })(<Select disabled={disabledFlag}>
											  <Option value='1'>有效</Option>
											  <Option value='0'>无效</Option>
										  </Select>)}
									  </FormItem>
								  </Col>
							  </Row>
							
							  <Row>
								  <FormItem label="管理区域">
									  {getFieldDecorator('areaIdList')(<TreeSelect
										  dropdownStyle={{maxHeight:'150px',overflow:'auto'}}
										  style={{ width: '100%' }}
										  placeholder={this.state.placeholder}
										  allowClear
										  showCheckedStrategy='SHOW_PARENT'
										  multiple={true}
										  disabled={disabledFlag}
										  treeDefaultExpandAll
										  treeData={this.state.areaList}
										  treeCheckable={true}
									  />)}
								  </FormItem>
							  </Row>
							
							  <Row>
								  <FormItem label="描述">
									  {getFieldDecorator('description')(<TextArea rows={4} disabled={disabledFlag}/>)}
								  </FormItem>
							  </Row>
						
						  </Form>
						  {
						  	disabledFlag?
								''
								:
								<div style={{textAlign:'center'}}>
									<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
									<Button style={{marginLeft:'20px'}} onClick={this.cancelHandle.bind(this)}>取消</Button>
								</div>
						  }
					  </div>
          </div>
        </div>
	}
}
export default Form.create()(Org)



// WEBPACK FOOTER //
// ./src/routes/org/index.js